import { ZONES, zoneOf } from "./Continents.js";

/**
 * Parties par continent pour Flag Nerd et Capital Nerd Classic (50 du TODO).
 *
 * 193 questions d'affilée, c'est un gros engagement ; « les 54 drapeaux
 * d'Afrique » est un objectif qu'on boucle en une session. La zone passe par
 * l'URL (`?zone=af`), ce qui la rend partageable et la garde au rechargement.
 * Comme pour Map Nerd, elle s'insère dans le `gameId` (`flagnerd.af`) : chaque
 * zone a sa partie en cours et son record, et seule la partie Monde est classée
 * (les `gameId` par zone ne figurent pas dans `VALID_GAME_IDS` côté serveur).
 */
export function readZone(search = window.location.search) {
	const zone = new URLSearchParams(search).get("zone");
	return ZONES.includes(zone) ? zone : null;
}

export function scopedGameId(base, zone) {
	return zone ? `${base}.${zone}` : base;
}

/** Pays de la zone (tous si pas de zone). */
export function zoneCountries(countries, zone) {
	return zone ? countries.filter(c => zoneOf(c.code) === zone) : countries;
}

/**
 * Barre de zones au-dessus de la partie : Monde (classé) puis les quatre
 * continents (entraînement). Simples liens : changer de zone recharge la page
 * sur la partie de cette zone.
 */
export function renderZoneBar(page, zone) {
	const anchor = page.querySelector(".title-container");
	if (!anchor || page.querySelector(".zone-bar")) return;
	const lang = window.geoNerdApp.languageManager;
	const path = window.location.pathname;
	const link = (value, label, badgeKey) => {
		const active = (value || null) === zone;
		const href = value ? `${path}?zone=${value}` : path;
		return `<a class="zone-link${active ? " active" : ""}" href="${href}"${active ? ' aria-current="page"' : ""}>${label}${badgeKey ? ` <span class="zone-badge">${lang.t(badgeKey)}</span>` : ""}</a>`;
	};
	anchor.insertAdjacentHTML("afterend", `
		<nav class="zone-bar" aria-label="${lang.t("zones.label")}">
			${link(null, lang.t("mapExploration.worldLabel"), "mapExploration.rankedLabel")}
			${ZONES.map(z => link(z, lang.t(`mapExploration.continents.${z}`))).join("")}
		</nav>
		${zone ? `<p class="zone-note">${lang.t("zones.trainingNote")}</p>` : ""}`);
}
